export default "__VITE_ASSET__BAPu8AAZ__"